export class UserOtp{
    dialCode!:string;
    phoneNumber!:string;
    clientNumber!:number ;

}